import React from "react";
import { Outlet } from "react-router-dom";
import { Page, Button, Tabs, type Tab } from "@ui";
import { User, Globe } from "lucide-react";

const tabs: Tab[] = [
  {
    to: "/system/agentic/system-prompt/connected-user",
    label: "Utilisateur connecté",
    icon: User,
  },
  {
    to: "/system/agentic/system-prompt/profile-entrypoint",
    label: "Point d'entrée profil",
    icon: Globe,
  },
];

export function SystemPromptLayout() {
  return (
    <Page
      data-testid="system-prompt"
      title={
        <div className="flex items-center gap-4">
          <span>Prompt système</span>
          <Tabs tabs={tabs} />
        </div>
      }
      actions={
        <Button variant="white" to="/system/agentic/agents">
          Retour aux agents
        </Button>
      }
    >
      <Outlet />
    </Page>
  );
}
